<template>
  <v-card dark toolbar class="organization press">
    <v-toolbar class="transparent elevation-0 my-3">
      <div class="headline">{{ organization.name }} in the Press</div>
      <v-spacer />
      <can I="edit" a="Organization">
        <v-menu left bottom :close-on-content-click="false" v-model="adding">
          <v-btn round slot="activator" color="secondary">
            <v-icon left>mdi-plus</v-icon> Add Press
          </v-btn>
          <v-card width="600px">
            <v-card-title class="title">
              New Press Link
            </v-card-title>
            <v-form v-model="valid">
              <v-card-text>
                <v-text-field label="Link" v-model="link.url" required :rules="rules.url" />

                <v-text-field
                  label="Title"
                  v-model="link.title"
                  persistent-hint
                  hint="Will be retrieved from the page automatically"
                />

                <v-text-field
                  label="Image"
                  prepend-icon="mdi-file-image"
                  type="search"
                  :value="link.preview && link.preview.name"
                  @click.native="$refs.file.click()"
                  persistent-hint
                  hint="Will be retrieved from the page automatically"
                />
                <input
                  type="file"
                  name="file"
                  ref="file"
                  @change="setFile"
                  style="display: none;"
                />
              </v-card-text>

              <v-card-actions>
                <v-btn flat block @click="cancel" color="grey">
                  Cancel
                </v-btn>
                <v-btn block @click="create" :disabled="!valid" color="primary">
                  Add
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-menu>
      </can>
    </v-toolbar>

    <v-container grid-list-lg fluid>
      <v-layout row wrap>
        <v-flex v-for="link in organization.pressLinks" :key="`press-${link.id}`" xs12 md6 d-flex>
          <v-card flat dark class="d-flex">
            <can I="edit" a="Organization">
              <v-btn small fab absolute top right @click="remove(link)" class="mt-4" color="error">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </can>
            <v-img
              :src="link.preview"
              :aspect-ratio="16 / 9"
              class="white--text"
              :class="{ 'with-scrim': link.title.length > 0 }"
            >
              <v-layout row fill-height align-end>
                <v-flex class="text-xs-center pa-0">
                  <p>{{ link.title }}</p>
                </v-flex>
              </v-layout>
              <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate />
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  data() {
    return {
      // Toggle the new Press Link Form
      adding: false,
      // Shows a busy indicator while removing
      removing: false,
      // Model - used to build the form data
      link: {
        url: '',
        title: '',
        preview: null,
      },
      // Validations
      valid: false,
      rules: {
        url: [v => !!v || 'You must provide a link'],
      },
    }
  },
  computed: mapGetters({
    organization: 'admin/organizations/find',
  }),
  methods: {
    add() {
      this.adding = true
    },
    cancel() {
      this.adding = false
      this.link.url = ''
      this.link.title = ''
      this.link.preview = null
    },
    setFile() {
      this.link.preview = this.$refs.file.files[0]
    },
    create() {
      let formData = new FormData()
      formData.append('preview', this.link.preview)
      formData.append('title', this.link.title)
      formData.append('url', this.link.url)
      formData.append('organization_id', this.organization.id)
      this.$store
        .dispatch('admin/organizations/createPressLink', {
          organization: this.organization,
          formData,
        })
        .then(this.cancel)
    },
    remove(link) {
      this.removing = true
      this.$store
        .dispatch('admin/organizations/removePressLink', {
          organization: { id: this.organization.id },
          pressLink: { id: link.id },
        })
        .then(() => (this.removing = false))
    },
  },
}
</script>

<style lang="scss">
.organization.press {
  .with-scrim {
    text-shadow: 0 0 2px black, 0 0 4px black;

    .v-image__image::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-image: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.7) 0%,
        rgba(0, 0, 0, 0.5) 30%,
        rgba(0, 0, 0, 0.2) 100%
      );
    }
  }
}
</style>
